import type { DeckIdentity } from "@/interfaces/DeckIdentity";
import archetypes from "@/lib/games/unionArena/data/archetypes.json";
import { getGameHandler } from "@/games";
import { getImgproxyUrl } from "@/lib/imgproxy";
import { gameAssetUrl } from "@/lib/cdn";

function getImage(id: string): string {
  return getImgproxyUrl(
    gameAssetUrl("union-arena", "archetype-squares", `${id}.webp`, "1.0.6"),
  );
}

export function getArchetypeDataUA(archetypeId: string): DeckIdentity {
  const archetype = archetypes[archetypeId as keyof typeof archetypes];
  let asplit = archetypeId.split("-");
  let set_color = asplit[0];
  // for names like Den-O
  let name = asplit.slice(1).join("-").trim();
  let [set, color] = set_color.trim().split(" ");
  let img = "";

  if (archetype) {
    img = getImage(archetype.image);
  } else {
    const gameHandler = getGameHandler("union-arena");
    img = gameHandler.getSetImage(set);
  }

  const curArchetype: DeckIdentity = {
    id: archetypeId,
    name: name,
    color: getColorFromAbbreviation(color),
    set: set,
    image: img,
  };

  return curArchetype;
}

function getColorFromAbbreviation(color: string): string {
  switch (color) {
    case "R":
      return "Red";
    case "B":
      return "Blue";
    case "Y":
      return "Yellow";
    case "G":
      return "Green";
    case "P":
      return "Purple";
  }
  return "";
}
